
(function initAmountSavings() {
  class AmountSavingsManager {
    constructor() {
    }

    calculate(compareAt, price) {
      if (!compareAt || compareAt <= price) return null;
      const savingsAmount = compareAt - price;
      const savingsPercent = Math.round((savingsAmount / compareAt) * 100);

      return {
        savingsAmount,
        savingsPercent
      };
    }

    // Mirrors the `money_without_trailing_zeros` Liquid filter used by the SSR'd badge.
    formatMoney(cents) {
      if (!window.theme || !window.theme.Currency) return '';
      return window.theme.Currency.formatMoney(cents, window.theme.strings.moneyFormat).replace(/\.00$/, '');
    }

    createBadge(layout) {
      const badge = document.createElement('div');
      badge.className = 'amount-savings-badge amount-savings-badge--' + layout;
      badge.setAttribute('data-amount-savings-badge', '');

      return badge;
    }

    updateBadge(badge, compareAt, price) {
      if (!badge) return;

      const savings = this.calculate(compareAt, price);

      badge.dataset.compareAt = compareAt || '';
      badge.dataset.price = price || '';

      if (!savings) {
        badge.hidden = true;
        return;
      }

      badge.hidden = false;

      const label = badge.querySelector('span') || badge;
      label.textContent = 'Save ' + this.formatMoney(savings.savingsAmount);
    }

    getPdpMultiplier(productSingle) {
      let multiplier = 1;
      const checkedToggle = productSingle.querySelector('.product__form__option__toggle[checked][data-multiplier]');

      if (checkedToggle) {
        multiplier = parseInt(checkedToggle.dataset.multiplier, 10) || 1;
      } else {
        const multiplierInput = productSingle.querySelector('input[name="multiplier"]');
        if (multiplierInput && multiplierInput.value) {
          multiplier = parseInt(multiplierInput.value, 10) || 1;
        }
      }

      return multiplier;
    }

    updatePdpBadges(productSingle, variant) {
      if (!productSingle || !variant) return;

      const multiplier = this.getPdpMultiplier(productSingle);
      const compareAt = variant.compare_at_price ? variant.compare_at_price * multiplier : 0;
      const price = variant.price * multiplier;

      productSingle.querySelectorAll('.price-container-with-savings').forEach((wrapper) => {
        let badge = wrapper.querySelector('[data-amount-savings-badge]');

        if (!badge && compareAt > price) {
          badge = this.createBadge('pdp');
          wrapper.appendChild(badge);
        }

        this.updateBadge(badge, compareAt, price);
      });
    }

    updateProductTileBadge(tile) {
      if (!tile) return;

      const wrapper = tile.querySelector('.product-tile__meta__price-with-savings');
      if (!wrapper) return;

      let badge = wrapper.querySelector('[data-amount-savings-badge]');
      let multiplier = parseInt(tile.dataset.defaultMultiplier || '1', 10);
      const selectedDot = tile.querySelector('.product-tile__hover--color__dot[selected]');

      if (selectedDot && selectedDot.dataset.multiplier) {
        multiplier = parseInt(selectedDot.dataset.multiplier, 10) || multiplier;
      }

      let compareAt = badge ? parseInt(badge.dataset.compareAt, 10) : 0;
      let price = badge ? parseInt(badge.dataset.price, 10) : 0;
      const form = tile.querySelector('.product-tile__hover--quick-buy__form');

      if (form) {
        const productJsonScript = form.querySelector('[product-json]');
        const idField = form.querySelector('input[name="id"]');

        if (productJsonScript && idField && idField.value) {
          try {
            const product = JSON.parse(productJsonScript.innerHTML.trim());
            const variant = product.variants.find((item) => {
              return String(item.id) === String(idField.value);
            });

            if (variant) {
              compareAt = variant.compare_at_price ? variant.compare_at_price * multiplier : 0;
              price = variant.price * multiplier;
            }
          } catch (error) {
            return;
          }
        }
      }

      if (!badge && compareAt > price) {
        badge = this.createBadge('plp');
        wrapper.appendChild(badge);
      }

      this.updateBadge(badge, compareAt, price);
    }

    initPdp() {
      if (typeof jQuery === 'undefined') return;

      // theme.Product's $container (where variantChange fires) is the outer
      // [data-section-type="template_product"] wrapper, not .product-single (a descendant of it).
      jQuery(document).on('variantChange', '[data-section-type="template_product"]', (event) => {
        if (!event.variant) return;
        this.updatePdpBadges(event.currentTarget, event.variant);
      });
    }

    initProductTiles(root) {
      const scope = root || document;
      scope.querySelectorAll('.product-tile__container').forEach((tile) => {
        this.updateProductTileBadge(tile);
      });
    }

    wrapProductTileInit() {
      if (!window.dAgency || typeof window.dAgency.initProductTile !== 'function') return;

      const originalInitProductTile = window.dAgency.initProductTile;

      window.dAgency.initProductTile = (tile) => {
        originalInitProductTile(tile);
        this.updateProductTileBadge(tile);
      };
    }

    init() {
      this.initPdp();
      this.wrapProductTileInit();
      this.initProductTiles();

      document.addEventListener('change', (event) => {
        const form = event.target.closest('.product-tile__hover--quick-buy__form');
        if (!form) return;

        const tile = form.closest('.product-tile__container');
        this.updateProductTileBadge(tile);
      });

      document.addEventListener('click', (event) => {
        const dot = event.target.closest('.product-tile__hover--color__dot');
        if (!dot) return;

        const tile = dot.closest('.product-tile__container');
        window.setTimeout(() => {
          this.updateProductTileBadge(tile);
        }, 0);
      });
    }
  }

  window.AmountSavings = new AmountSavingsManager();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.AmountSavings.init();
    });
  } else {
    window.AmountSavings.init();
  }
})();
if (window.innerWidth < 768) {
    const shippingBadge = document.querySelectorAll('.free-shipping-badge');
    if(shippingBadge.length > 0) {
        shippingBadge.forEach(badge => {
            badge.addEventListener('click', (e) => {
                e.currentTarget.classList.toggle('active');
            });
        });
    }
}

(function initMinicartRecommendations() {
  const minicartContent = document.querySelector('#CartDrawer .minicart__content');
  if (!minicartContent || typeof Shopify === 'undefined') return;

  const MAX_VISIBLE = 10;
  let requestedProductId = null;
  let cachedSectionHTML = '';

  // This theme lists the most recently added line item first, not last.
  const getLastAddedProductId = () => {
    const firstRow = minicartContent.querySelector(
      '.minicart__products-wrapper .minicart__product[data-product-id]',
    );
    return firstRow ? firstRow.dataset.productId : null;
  };

  const excludeCartDuplicates = (container) => {
    const cartProductIds = new Set(
      Array.from(
        minicartContent.querySelectorAll(
          '.minicart__products-wrapper .minicart__product[data-product-id]',
        ),
      ).map((row) => row.dataset.productId),
    );
    container.querySelectorAll('.minicart-recommendations__item').forEach((item) => {
      if (cartProductIds.has(item.dataset.productId)) item.remove();
    });
  };

  // Trims to MAX_VISIBLE after duplicates are excluded, so the fetch's larger buffer
  // (limit=10) can backfill slots that duplicates would otherwise have left empty.
  const limitVisibleItems = (container) => {
    container.querySelectorAll('.minicart-recommendations__item').forEach((item, index) => {
      if (index >= MAX_VISIBLE) item.remove();
    });
  };

  const onAddRecommendation = async (e) => {
    const button = e.currentTarget;
    button.disabled = true;
    try {
      await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.dataset.variantId, quantity: 1 }),
      });
      if (window.dAgency?.openMinicart) window.dAgency.openMinicart(false);
      if (window.dAgency?.loadMinicart) await window.dAgency.loadMinicart();
    } catch (error) {
      button.disabled = false;
      console.error('Failed to add recommended product', error);
    }
  };

  const bindAddButtons = (container) => {
    container.querySelectorAll('.minicart-recommendations__add').forEach((button) => {
      button.addEventListener('click', onAddRecommendation);
    });
  };

  // Arrows are an extra way to move the same scroller touch/swipe already scrolls
  // natively (overflow-x: auto) — this only adds click-to-scroll and keeps the
  // buttons' disabled state in sync whichever way the user scrolls.
  const bindNav = (container) => {
    const list = container.querySelector('[data-minicart-recommendations-list]');
    const nav = container.querySelector('[data-minicart-recommendations-nav]');
    const prevButton = container.querySelector('[data-minicart-recommendations-prev]');
    const nextButton = container.querySelector('[data-minicart-recommendations-next]');
    if (!list || !nav || !prevButton || !nextButton) return;

    const updateNavState = () => {
      const maxScrollLeft = list.scrollWidth - list.clientWidth;
      nav.hidden = maxScrollLeft <= 1;
      prevButton.disabled = list.scrollLeft <= 0;
      nextButton.disabled = list.scrollLeft >= maxScrollLeft - 1;
    };

    prevButton.addEventListener('click', () => {
      list.scrollBy({ left: -list.clientWidth * 0.8, behavior: 'smooth' });
    });
    nextButton.addEventListener('click', () => {
      list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' });
    });
    list.addEventListener('scroll', updateNavState, { passive: true });

    updateNavState();
  };

  // Renders whatever markup we currently have (cached or freshly fetched) into the
  // container. Needed on every refresh, not only when a new fetch runs: loadMinicart()
  // always swaps [data-minicart-recommendations] back to an empty node from the server.
  const render = (container) => {
    container.innerHTML = cachedSectionHTML;
    excludeCartDuplicates(container);
    limitVisibleItems(container);
    bindAddButtons(container);
    bindNav(container);
  };

  const refreshRecommendations = async () => {
    const container = minicartContent.querySelector('[data-minicart-recommendations]');
    if (!container) return;

    const productId = getLastAddedProductId();
    if (!productId) {
      requestedProductId = null;
      cachedSectionHTML = '';
      container.innerHTML = '';
      return;
    }
    if (productId === requestedProductId) {
      render(container);
      return;
    }
    requestedProductId = productId;

    try {
      const url = `${Shopify.routes.root}recommendations/products?section_id=minicart-recommendations&product_id=${productId}&limit=10`;
      const response = await fetch(url);
      const html = await response.text();
      const doc = document.createElement('div');
      doc.innerHTML = html;
      const section = doc.querySelector('[data-minicart-recommendations-section]');
      cachedSectionHTML = section ? section.outerHTML : '';
      render(container);
    } catch (error) {
      console.error('Failed to load minicart recommendations', error);
    }
  };

  // the theme's loadMinicart() always replaces .minicart__content's direct
  // children wholesale (drawer open, qty change, remove, any cart/add.js flow), so
  // observing that swap covers every refresh path without depending on script load
  // order or hooking window.dAgency directly. childList (no subtree) ignores the
  // nested [data-minicart-recommendations] mutations we make ourselves below.
  new MutationObserver(refreshRecommendations).observe(minicartContent, { childList: true });
})();

(function initA11yNavAndColorControls() {
  const header = document.getElementById('header');
  if (header) {
    const syncDesktopTriggers = () => {
      header
        .querySelectorAll(
          '.header__desktop-menu--dropdown__inline-elements__link'
        )
        .forEach((item) => {
          const panel = item.querySelector(
            '.header__desktop-menu--dropdown__dropdown-wrapper'
          );
          const trigger = item.querySelector(
            'button.header__desktop-menu--dropdown__inline-elements__link__text'
          );
          if (!panel || !trigger) return;
          trigger.setAttribute(
            'aria-expanded',
            panel.classList.contains('open') ? 'true' : 'false'
          );
        });
    };

    const syncMobileDrawer = () => {
      const drawer = header.querySelector('#MobileNavDrawer');
      const burger = header.querySelector('button.header__burger-icon');
      if (drawer && burger) {
        burger.setAttribute(
          'aria-expanded',
          drawer.classList.contains('open') ? 'true' : 'false'
        );
      }

      header
        .querySelectorAll(
          '.header__mobile-menu--drawer__second-level[data-submenu]'
        )
        .forEach((panel) => {
          const submenu = panel.getAttribute('data-submenu');
          const title = header.querySelector(
            `.header__mobile-menu--drawer__first-level__title[data-submenu="${submenu}"]`
          );
          const trigger = title
            ? title.querySelector(
                'button.header__mobile-menu--drawer__first-level__trigger'
              )
            : null;
          if (!trigger) return;
          trigger.setAttribute(
            'aria-expanded',
            panel.classList.contains('open') ? 'true' : 'false'
          );
        });
    };

    const syncAll = () => {
      syncDesktopTriggers();
      syncMobileDrawer();
    };

    syncAll();
    new MutationObserver(syncAll).observe(header, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });

    const closeDesktopPanel = (item) => {
      const panel = item.querySelector(
        '.header__desktop-menu--dropdown__dropdown-wrapper'
      );
      if (!panel) return;
      panel.classList.remove('open');
      item.classList.remove('active');
      header.classList.remove('force-opacity');
    };

    const openDesktopPanel = (item) => {
      header
        .querySelectorAll(
          '.header__desktop-menu--dropdown__inline-elements__link'
        )
        .forEach((other) => {
          if (other !== item) closeDesktopPanel(other);
        });
      const panel = item.querySelector(
        '.header__desktop-menu--dropdown__dropdown-wrapper'
      );
      if (!panel) return;
      panel.classList.add('open');
      item.classList.add('active');
      header.classList.add('force-opacity');
    };

    header.addEventListener('keydown', (event) => {
      const desktopTrigger = event.target.closest(
        'button.header__desktop-menu--dropdown__inline-elements__link__text'
      );
      if (desktopTrigger) {
        const item = desktopTrigger.closest(
          '.header__desktop-menu--dropdown__inline-elements__link'
        );
        const panel = item
          ? item.querySelector(
              '.header__desktop-menu--dropdown__dropdown-wrapper'
            )
          : null;
        if (!item || !panel) return;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (panel.classList.contains('open')) {
            closeDesktopPanel(item);
          } else {
            openDesktopPanel(item);
          }
          syncDesktopTriggers();
          return;
        }

        if (event.key === 'Escape' && panel.classList.contains('open')) {
          event.preventDefault();
          closeDesktopPanel(item);
          desktopTrigger.focus();
          syncDesktopTriggers();
          return;
        }
      }

      if (event.key === 'Escape') {
        const openSubmenu = header.querySelector(
          '.header__mobile-menu--drawer__second-level.open'
        );
        if (openSubmenu) {
          event.preventDefault();
          const closeBtn = openSubmenu.querySelector(
            '.header__mobile-menu--drawer__second-level__close'
          );
          if (closeBtn) {
            closeBtn.click();
          } else {
            openSubmenu.classList.remove('open');
          }
          const submenu = openSubmenu.getAttribute('data-submenu');
          const title = header.querySelector(
            `.header__mobile-menu--drawer__first-level__title[data-submenu="${submenu}"] button`
          );
          if (title) title.focus();
          syncMobileDrawer();
          return;
        }

        const drawer = header.querySelector('#MobileNavDrawer.open');
        const burger = header.querySelector('button.header__burger-icon');
        if (drawer && burger) {
          event.preventDefault();
          burger.click();
          burger.focus();
          syncMobileDrawer();
        }
      }
    });

    header.addEventListener('click', (event) => {
      const desktopTrigger = event.target.closest(
        'button.header__desktop-menu--dropdown__inline-elements__link__text'
      );
      if (!desktopTrigger) return;
      // Hover already opens via theme JS; click supports keyboard-focus + mouse activation.
      const item = desktopTrigger.closest(
        '.header__desktop-menu--dropdown__inline-elements__link'
      );
      const panel = item
        ? item.querySelector(
            '.header__desktop-menu--dropdown__dropdown-wrapper'
          )
        : null;
      if (!item || !panel) return;
      if (panel.classList.contains('open')) {
        // Leave open if opened by hover; only toggle-close when already keyboard-opened
        // without pointer hover would be surprising — keep open on click.
        return;
      }
      openDesktopPanel(item);
      syncDesktopTriggers();
    });
  }

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('.product-tile__hover--color__dot');
    if (!dot) return;
    const tile = dot.closest('.product-tile__container');
    if (!tile) return;
    window.setTimeout(() => {
      tile
        .querySelectorAll('.product-tile__hover--color__dot')
        .forEach((sibling) => {
          const isSelected =
            sibling.hasAttribute('selected') &&
            sibling.getAttribute('selected') !== 'false';
          sibling.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
    }, 0);
  });
})();

(function initAccessibleVideoControls() {
  function initVideoControls() {
    document.querySelectorAll('.media__container').forEach(function (container) {
      const button = container.querySelector(
        '.media__custom-controls__toggle'
      );

      const videos = container.querySelectorAll('video');

      if (!button || !videos.length || button.dataset.videoControlsInitialized === 'true') {
        return;
      }

      button.dataset.videoControlsInitialized = 'true';

      const pauseIcon = button.querySelector(
        '.media__custom-controls__pause'
      );

      const playIcon = button.querySelector(
        '.media__custom-controls__play'
      );

      function getActiveVideo() {
        return (
          Array.from(videos).find(function (video) {
            return video.offsetWidth > 0 && video.offsetHeight > 0;
          }) || videos[0]
        );
      }

      function updateButton(video) {
        if (!video) return;

        const paused = video.paused;

        button.setAttribute(
          'aria-label',
          paused ? 'Play video' : 'Pause video'
        );

        if (pauseIcon) {
          pauseIcon.hidden = paused;
        }

        if (playIcon) {
          playIcon.hidden = !paused;
        }
      }

      button.addEventListener('click', function () {
        const video = getActiveVideo();

        if (!video) return;

        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }

        updateButton(video);
      });

      videos.forEach(function (video) {
        video.addEventListener('play', function () {
          updateButton(video);
        });

        video.addEventListener('pause', function () {
          updateButton(video);
        });

        video.addEventListener('ended', function () {
          updateButton(video);
        });
      });

      updateButton(getActiveVideo());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoControls);
  } else {
    initVideoControls();
  }

  /*
   * Some Shopify sections can be dynamically loaded or replaced.
   * Re-check when the page DOM changes.
   */
  const observer = new MutationObserver(function () {
    initVideoControls();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* =========================================
   PDP COLOR SWATCH TOOLTIPS
   ========================================= */

(function initColorSwatchTooltips() {
  var tooltip = null;

  function getTooltip() {
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'pdp-color-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      document.body.appendChild(tooltip);
    }

    return tooltip;
  }

  function showTooltip(label) {
    if (!label) return;

    var color = label.getAttribute('data-color-value');

    if (!color) return;

    /*
     * Convert the color name to Title Case.
     * Examples:
     * "sage"       → "Sage"
     * "dark gray"  → "Dark Gray"
     * "steel blue" → "Steel Blue"
     */
    color = color
      .toLowerCase()
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      });

    var tip = getTooltip();
    var rect = label.getBoundingClientRect();

    tip.textContent = color;
    tip.classList.add('is-visible');

    /*
     * Position the tooltip above the swatch.
     * The 12px gap keeps it separated from the swatch.
     */
    var left = rect.left + (rect.width / 2) - (tip.offsetWidth / 2);
    var top = rect.top - tip.offsetHeight - 12;

    /*
     * Keep the tooltip inside the browser window horizontally.
     */
    left = Math.max(
      8,
      Math.min(
        left,
        window.innerWidth - tip.offsetWidth - 8
      )
    );

    /*
     * If there isn't enough room above,
     * place the tooltip below the swatch.
     */
    if (top < 8) {
      top = rect.bottom + 12;
    }

    tip.style.left = left + 'px';
    tip.style.top = top + 'px';
  }

  function hideTooltip() {
    if (tooltip) {
      tooltip.classList.remove('is-visible');
    }
  }

  /* =========================================
     MOUSE
     ========================================= */

  document.addEventListener('mouseover', function (event) {
    var label = event.target.closest(
      '.product__form__option__toggle'
    );

    if (label) {
      showTooltip(label);
    }
  });

  document.addEventListener('mouseout', function (event) {
    var label = event.target.closest(
      '.product__form__option__toggle'
    );

    if (!label) return;

    /*
     * Don't hide the tooltip when moving between
     * elements inside the same swatch label.
     */
    if (!label.contains(event.relatedTarget)) {
      hideTooltip();
    }
  });

  /* =========================================
     KEYBOARD ACCESSIBILITY
     ========================================= */

  document.addEventListener('focusin', function (event) {
    var input = event.target.closest(
      '.product__form__option__container input[type="radio"]'
    );

    if (!input) return;

    var label = document.querySelector(
      'label[for="' + CSS.escape(input.id) + '"]'
    );

    if (label) {
      showTooltip(label);
    }
  });

  document.addEventListener('focusout', function (event) {
    var input = event.target.closest(
      '.product__form__option__container input[type="radio"]'
    );

    if (input) {
      hideTooltip();
    }
  });

  /* =========================================
     REPOSITION WHILE SCROLLING
     ========================================= */

  window.addEventListener(
    'scroll',
    function () {
      if (
        !tooltip ||
        !tooltip.classList.contains('is-visible')
      ) {
        return;
      }

      var activeLabel = document.querySelector(
        '.product__form__option__toggle:hover'
      );

      if (activeLabel) {
        showTooltip(activeLabel);
      }
    },
    { passive: true }
  );

  /* =========================================
     REPOSITION WHEN WINDOW RESIZES
     ========================================= */

  window.addEventListener('resize', function () {
    if (
      !tooltip ||
      !tooltip.classList.contains('is-visible')
    ) {
      return;
    }

    var activeLabel = document.querySelector(
      '.product__form__option__toggle:hover'
    );

    if (activeLabel) {
      showTooltip(activeLabel);
    }
  });
})();